import type { TOC } from '@ember/component/template-only';

interface S {
  Element: HTMLButtonElement;
  Args: { isReadOnly?: boolean };
  Blocks: { default: [] };
}

const ActionButton: TOC<S> = <template>
  {{#unless @isReadOnly}}
    {{! Force the type to "button" otherwise it is a "submit" type in a form }}
    <button type='button' ...attributes>{{yield}}</button>
  {{/unless}}
</template>;

export default ActionButton;
